import AlertDialog from '@/components/atom/AlertDialog';
import useDialogStore from '@/src/store/useDialogStore';

function GlobalDialog() {
  const { isOpen, setClose, titleText, bodyText, hasCloseButton } =
    useDialogStore();

  return (
    <AlertDialog
      open={isOpen}
      onOpenChange={setClose}
      title={titleText}
      cancelButtonProps={{
        style: { display: hasCloseButton ? 'flex' : 'none' },
      }}
    >
      <p className="whitespace-pre-wrap">{bodyText}</p>
    </AlertDialog>
  );
}

export default GlobalDialog;
